/**
 * Rupee amounts for UI and customer-facing strings: always two decimal places.
 * Uses en-IN grouping (e.g. 1,234.56).
 */
export function formatInrAmount(value) {
  let n;
  if (typeof value === "string") {
    const cleaned = value.replace(/,/g, "").replace(/[^\d.-]/g, "").trim();
    n = Number(cleaned);
  } else {
    n = Number(value);
  }
  if (!Number.isFinite(n)) return "0.00";
  return n.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
